import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import employee from '../class/employee.js';
import { formatRpcError } from '../class/jrpc20WSClient';
import swal from 'sweetalert';
import "../styles/LoginPage.css";

// Login portale Magazzino Packaging: SOLO badge. Il backend risolve la qualifica dal
// contratto e rifiuta chi non è magazziniere (qualifica 3). Nessuna password, nessuno
// step ordine: lo scanner digita il numero badge ed emette Enter.
function Login() {
    const [numeroAddetto, setNumeroAddetto] = useState('');
    const navigate = useNavigate();
    const inputAddettoRef = useRef(null);

    const handleAddettoKeyDown = (event) => {
        if (event.key === 'Enter' && numeroAddetto.trim() !== '') {
            const loginWS = new employee();
            loginWS.authenticate({ employee_number: numeroAddetto }).then(() => {
                navigate('/home');
            }).catch((error) => {
                swal("Errore", formatRpcError(error), "error");
                setNumeroAddetto('');
                setTimeout(() => inputAddettoRef.current?.focus(), 0);
            });
        }
    };

    useEffect(() => {
        // Sessione persistente: se il token è valido e la qualifica è Magazzinieri, salta il login.
        const user_obj = new employee();
        user_obj.isLogged().then(() => {
            navigate('/home');
        }).catch(() => {
            // non loggato: resta sul login
        });
        if (inputAddettoRef.current) {
            inputAddettoRef.current.focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="login-container">
            <form className='form-login' onSubmit={(e) => e.preventDefault()}>
                <div>
                    <h2 className='login-title'>Magazzino Packaging</h2>
                </div>
                <div className='login-form'>
                    <div className='login-form-block'>
                        <label htmlFor="numeroAddetto">Scansiona il badge:</label>
                        <input
                            type="text"
                            id="numeroAddetto"
                            value={numeroAddetto}
                            onChange={(e) => setNumeroAddetto(e.target.value)}
                            onKeyDown={handleAddettoKeyDown}
                            className='login-item'
                            autoComplete="off"
                            placeholder="N. Addetto"
                            ref={inputAddettoRef}
                            required
                        />
                    </div>
                </div>
            </form>
        </div>
    );
}

export default Login;
